import { Reciter } from '../class/reciter';
import { routes } from '../const/routes';

const personMarkupSchema = (reciter: Reciter) => {
  const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
  const url = `${SITE_URL}${routes.reciters}/${reciter.slug}`;

  const sameAs = [
    reciter.facebook,
    reciter.twitter,
    reciter.instagram,
    reciter.youtube,
    reciter.snapchat,
  ].filter(Boolean);

  return {
    '@type': 'Person',
    '@id': `${url}#person`,
    name: reciter.titleEn,
    url,
    ...(reciter.image?.originalUrl && { image: reciter.image.originalUrl }),
    ...(reciter.biblioEn && { description: reciter.biblioEn }),
    ...(sameAs.length && { sameAs }),
  };
};

export default personMarkupSchema;
